import { render, staticRenderFns } from "./YamiAuthorize.vue?vue&type=template&id=61fbfa6c&scoped=true"
import script from "./YamiAuthorize.vue?vue&type=script&lang=js"
export * from "./YamiAuthorize.vue?vue&type=script&lang=js"
import style0 from "./YamiAuthorize.vue?vue&type=style&index=0&id=61fbfa6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fbfa6c",
  null
  
)

export default component.exports